import React, { useState, useEffect, useContext } from "react";
import { Table, Button, Row, Col } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";

import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";
import { MdPreview } from "react-icons/md";

import PreviewFeeInstallment from "./PreviewFeeInstallment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SessionContext } from "../SessionProvider";

function Fees(props) {
  const [fees, setFees] = useState([]);
  const [studentInstallments, setStudentInstallments] = useState([]);
  const [feeTypeOptions, setFeeTypeOptions] = useState([]);
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);
    const [upcomingTypes, setUpcomingType] = useState({
    Monthly: true,
    "Bi-Monthly": false,
    Quarterly: false,
    "Half Yearly": false,
  });
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handlePreviewClick = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };

  const header1 = [
    {
      title: "Month",
      prop: "month",
      isFilterable: true,
    },
    {
      title: "Installment Amt",
      prop: "total_inst_amt",
    },
    {
      title: "Other Amt",
      prop: "other_amount",
    },
    {
      title: "Deposited amt",
      prop: "deposit_amount",
      isFilterable: true,
      cell: (row) => (row.deposit_amount ? row.deposit_amount : 0),
    },
    {
      title: "Due Date",
      prop: "due_date",
      isFilterable: true,
      cell: (row) => formatDate(row.due_date),
    },
    {
      title: "Status",
      prop: "status",
      cell: (row) => (row.status === "completed" ? "Completed" : "Pending"),
    },
    {
      title: "Preview",
      prop: "",
      isFilterable: true,
      cell: (row) => (
        <Button title="Preview" onClick={() => handlePreviewClick(row)}>
          <MdPreview />
        </Button>
      ),
    },
  ];

  useEffect(() => {
    //fetchFees();
    fetchInstallments();
  }, []);

  const fetchInstallments = async () => {
    try {
      let result = await schoolApi.fetchStudentFeeInstallments(
        props?.studenId?.student_addmission_id
      );
      if (result.success) {
        
        setStudentInstallments(result.result);
      } else {
        setStudentInstallments([]);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  //const fetchFees = async () => {
  //  try {
  //    if (props?.studenId?.id !== null) {
  //      const result = await schoolApi.fetchStudentAddmission(
  //        selectedSessionId,props?.studenId?.id
  //      );
  //      if (result.success) {
  //        setFees(result?.studentAddmision);
  //      } else {
  //        setFees([]);
  //      }
  //    }
  //  } catch (error) {
  //    toast.error(error?.response?.data?.message);
  //  }
  //};

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Row className="mt-4 mb-3">
        <Col className="mx-3">
          <DatatableWrapper body={studentInstallments} headers={header1}>
            <Table striped className="data-table">
              <TableHeader />
              <TableBody />
            </Table>
          </DatatableWrapper>
        </Col>

        {showModal && (
          <PreviewFeeInstallment
            row={selectedRow}
            showModal={showModal}
            setShowModal={setShowModal}
          />
        )}
      </Row>
    </div>
  );
}

export default Fees;
